import axios from 'axios';
import { router } from '@inertiajs/react';
import { useCallback } from 'react';

import { useToast } from '@/hook/useToast';

export function useDeleteReel() {
    const { showToast, hideToast } = useToast();

    const restoreReel = useCallback(
        (reelId: number, reelName: string) => {
            axios
                .post(route('api.internal.reels.restore', { reelId }))
                .then(() => {
                    hideToast();

                    showToast({
                        autoClose: 5000,
                        variant: 'success',
                        label: `The video "${reelName}" has been restored`,
                    });

                    router.reload({ only: ['reels'] });
                })
                .catch(() => {
                    hideToast();

                    showToast({
                        autoClose: 5000,
                        variant: 'danger',
                        label: 'Failed to restore the video reel',
                    });
                });
        },
        [showToast, hideToast],
    );

    const deleteReel = useCallback(
        (reelId: number, reelName: string) => {
            return axios
                .delete(route('api.internal.reels.destroy', { reelId }))
                .then(() => {
                    showToast({
                        autoClose: 5000,
                        variant: 'success',
                        label: `The video "${reelName}" has been deleted`,
                        action: {
                            label: 'Undo',
                            href: '#',
                            onClick: (e) => {
                                e.preventDefault();
                                restoreReel(reelId, reelName);
                            },
                        },
                    });
                    router.reload({ only: ['reels'] });
                })
                .catch(() => {
                    showToast({
                        autoClose: 5000,
                        variant: 'danger',
                        label: 'Failed to delete the video reel',
                    });
                });
        },
        [showToast, restoreReel],
    );

    return { deleteReel, restoreReel };
}
